// extracted by mini-css-extract-plugin
module.exports = {"searchForm":"Customers_searchForm__2LNYB"};